import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useNavigate } from "react-router-dom";

import Ready from './Components/Ready';
import Preparing from './Components/Preparing';


import { APP_ROUTES } from '../utils/constants';
import { AblyProvider } from 'ably/react';


import Intercom from '@intercom/messenger-js-sdk';

const AppLayout = observer((props) => {
  const navigate = useNavigate();

  useEffect(() => {
    if(props.store.SessionStore.user?.sid){
      Intercom({
        app_id: 'wl1eynv5',
        user_id: props.store.SessionStore.user.sid,
        user_hash : props.store.SessionStore.user.chat.userHash,
        name: props.store.SessionStore.user.firstName,
        email: props.store.SessionStore.user.email,
        created_at: Math.floor(new Date(props.store.SessionStore.user.createdAt).getTime() / 1000)
      });
    }
  }, [props.store.SessionStore.user]);

  useEffect(() => {
    
    async function checkAuthentication() {
        // the user just signed in...get their info..
        const loginResult = await props.store.SessionStore.isAuthenticated();
    
        if(loginResult && loginResult.authenticated){
          if(loginResult.redirectTo){
            navigate(loginResult.redirectTo);
          }          
        }else{
          navigate(APP_ROUTES.SIGN_IN);
        }
    }
    
    // now call the get User Function...
    checkAuthentication();

  // eslint-disable-next-line
  }, [navigate]);

    return (
      <>
        {props.store.SessionStore.phase === 'ready' ? (
          <AblyProvider client={ props.store.SessionStore.ablyClient }>
            <Ready {...props} />
          </AblyProvider>
          ) : (<Preparing {...props} />)}
      </>
    );
});

export default AppLayout;